import React, { useState } from 'react';

// Hamburger menu for the phone top bar: switches between the same pages as the
// desktop tab nav (Workspace / User Guide / Settings / Profile / About).
const PAGES = [
  ['workspace', 'Workspace'],
  ['guide', 'User Guide'],
  ['settings', 'Settings'],
  ['profile', 'Profile'],
  ['about', 'About'],
];

export default function MobileMenu({ activeTab, setActiveTab }) {
  const [open, setOpen] = useState(false);
  const current = PAGES.find(([id]) => id === activeTab);

  return (
    <div className="m-menu">
      <button
        className="m-menu-btn"
        onClick={() => setOpen((o) => !o)}
        aria-label="Menu"
        aria-expanded={open}
      >
        <span className="m-menu-current">{current ? current[1] : 'Menu'}</span>
        <span className="m-menu-icon">☰</span>
      </button>
      {open && (
        <>
          <div className="m-menu-backdrop" onClick={() => setOpen(false)} />
          <div className="m-menu-list" role="menu">
            {PAGES.map(([id, label]) => (
              <button
                key={id}
                role="menuitem"
                className={`m-menu-item${activeTab === id ? ' active' : ''}`}
                onClick={() => { setActiveTab(id); setOpen(false); }}
              >
                {label}
              </button>
            ))}
          </div>
        </>
      )}
    </div>
  );
}
